import { all, AllEffect } from 'redux-saga/effects';
import SendFormsAndDocumentsReducer from './duck/reducer';
import { watchGetAllUsersForms, watchGetSearchUsersForms } from './duck/saga';

function* SendFormsAndDocumentsSaga(): Generator<AllEffect<Generator>> {
  yield all([watchGetAllUsersForms(), watchGetSearchUsersForms()]);
}

export { SendFormsAndDocumentsReducer, SendFormsAndDocumentsSaga };
